'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-grin';
var width = 512;
var height = 512;
var aliases = [128512,"grin"];
var unicode = 'f580';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm86.5 61.3c-3.4-11.7 8.4-21 20-17.3 39.9 12.8 85.3 20 133.5 20s93.6-7.2 133.5-20c11.6-3.7 23.4 5.6 20 17.3-19.5 66.3-80.9 114.7-153.5 114.7S122 383.6 102.5 317.3zM158 19.4C188.2 6.9 221.3 0 256 0s67.8 6.9 98 19.4c-30.1-12.9-63.2-20-98-20s-67.9 7.1-98 20zM192 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 80c-49.3 0-96-7.3-137.3-20.4 18.5 58.2 73 100.4 137.3 100.4s118.8-42.2 137.3-100.4C352 328.7 305.3 336 256 336zm153.5-18.7C390 383.6 328.6 432 256 432S122 383.6 102.5 317.3c-3.4-11.7 8.4-21 20-17.3 39.9 12.8 85.3 20 133.5 20s93.6-7.2 133.5-20c11.6-3.7 23.4 5.6 20 17.3zM160 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGrin = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;